module.exports = __webpack_public_path__ + "static/media/icn_travel_covid_myway.801e9765.svg";